export enum Modal {
  Bid = 'bid',
  Offer = 'offer',
  BuyNow = 'buyNow',
  SignIn = 'signIn',
}
